export interface Partners {
    organizationId?: number,
    partnerId?: string,
    organizationDisplayName?: string,
    email?: string,
    resendLimit?: number,
    resendLimitUnits?: string,
    testActivationLimit?: number,
    testActivationLimitUnits?: string,
    isTopconPartner?: boolean,
    adminFirstName?: string,
    adminLastName?: string,
    phone?: string,
    address1?: string,
    address2?: string,
    address3?: string,
    city?: string,
    state?: string,
    country?: string,
    zipcode?: string,
    mobilePhone?: string,
    mobilePhoneCountry?: string,
    taxPayerId?: string,
    organizationType?: string,
    password?: string;
    clientId?: string
}

export enum partnerTypeEnum{
    O = 'Organization',
    OU = 'Organization Unit',
    AD = 'Authorization Domain' 
}
